import { useQuery, UseQueryOptions } from "react-query";
import { API_URL, APIError, APIResponse, get } from "../api";
import { IntlTicketStatusResult } from "../@types/intlFlightAggregator";

/**
 * Checks whether e-ticket documents have been issued for a booking. Duffel
 * ticketing is asynchronous for many airlines — `documents` can come back
 * empty right after booking — so this is meant to be refetched (a
 * "Check again" action) rather than trusted on a single call.
 */
function useGetInternationalOrderTicket(
  bookingId: string | undefined,
  options?: Omit<UseQueryOptions<APIResponse<IntlTicketStatusResult>, APIError>, "queryKey" | "queryFn">
) {
  const query = useQuery<APIResponse<IntlTicketStatusResult>, APIError>({
    queryKey: ["international-order-ticket", bookingId],
    queryFn: () =>
      get(`${API_URL}/aviation/international/v2/bookings/${bookingId}/ticket`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      }),
    enabled: false,
    ...options,
  });

  return {
    ticket: query.data?.data,
    fetchTicket: query.refetch,
    isFetchingTicket: query.isFetching,
    ticketError: query.error,
    hasFetchedTicket: query.isFetched,
  };
}

export default useGetInternationalOrderTicket;
